import { getLocale } from "../runtime";

const sv_delivery = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Levereras om 1-2 arbetsdagar`
};

const delivery = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_delivery(inputs)
	return "delivery";
};

export { delivery as "delivery" };